import React from 'react';
import './PageStyles.css';

export default function TermsConditions() {
  return (
    <div className="legal-page">
      <div className="page-hero hero-gradient">
        <div className="container text-center">
          <span className="section-label" style={{ background: 'rgba(103,183,247,0.15)', color: 'var(--secondary)' }}>Legal</span>
          <h1>Terms & Conditions</h1>
          <p>Last updated: January 1, 2025</p>
        </div>
      </div>
      <section>
        <div className="container">
          <div className="legal-content">
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing or using the Pointfinity platform, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use our services.</p>

            <h2>2. Description of Service</h2>
            <p>Pointfinity is a multi-store loyalty and rewards platform that allows store owners to manage loyalty programs and customers to earn and redeem points across participating stores.</p>

            <h2>3. User Accounts</h2>
            <p>You must create an account to use certain features of Pointfinity. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>

            <h2>4. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use the platform for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to any part of the service</li>
              <li>Interfere with or disrupt the integrity or performance of the service</li>
              <li>Transmit any harmful, fraudulent, or misleading content</li>
            </ul>

            <h2>5. Points & Rewards</h2>
            <p>Points earned through Pointfinity have no cash value and may not be exchanged for cash. Points may expire as defined by individual store policies. Pointfinity reserves the right to modify or terminate any rewards program at any time.</p>

            <h2>6. Payment & Subscriptions</h2>
            <p>Subscription fees are billed monthly or annually as selected. All fees are non-refundable unless otherwise stated. We reserve the right to change pricing with 30 days' notice.</p>

            <h2>7. Intellectual Property</h2>
            <p>All content, trademarks, logos, and intellectual property on the Pointfinity platform are owned by Pointfinity or its licensors. You may not use them without prior written permission.</p>

            <h2>8. Limitation of Liability</h2>
            <p>Pointfinity shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the platform. Our total liability shall not exceed the amount paid by you in the past 12 months.</p>

            <h2>9. Termination</h2>
            <p>We reserve the right to suspend or terminate your account at any time for violation of these terms. You may terminate your account by contacting us at support@pointfinity.com.</p>

            <h2>10. Changes to Terms</h2>
            <p>We may update these Terms from time to time. Continued use of the platform after changes constitutes your acceptance of the updated Terms.</p>

            <h2>11. Contact</h2>
            <p>For questions about these Terms, contact us at legal@pointfinity.com.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
